jQuery(document).ready(function ($) {
    function wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    window.addEventListener(
      'resizeHeight',
      (e) => {
        mainDIVspacing();
      },
      false
    );

    mainDIVspacing();

    $(window).resize(function () {
        mainDIVspacing();
    })

    jQuery(document).on("scroll", function () {
        minimizeMenu();
        mainDIVspacing();
    });


    $('.hamburger').on('click', function (e) {
        e.stopPropagation();
        $(this).toggleClass('is-active');
        $(document).find('.navigation-container.-mobile').toggleClass('is-active');
        // $('.navigation-container').toggleClass('is-active');
    });


    $('[data-sub-menu]').on('click', function (e) {
        e.stopPropagation();
        var submenu = $(this).parent().find('.menu');
        if (submenu.length > 0) {
            submenu.toggleClass('is-active');
        }
    });

    $('[data-submenu-back]').on('click', function (e) {
        e.stopPropagation();
        $(this).parent('ul').toggleClass('is-active');
    });

    function mainDIVspacing() {
        var height = $('header').outerHeight(true) - 1;
        if ($(document).width() < 1000) {
            height = height + 10;
        }
        if ($('#wpadminbar').length) {
            height = height - $('#wpadminbar').outerHeight(true);
        }
        $('main').children().first().css('margin-top', height);
    }

    function minimizeMenu() {
        if (jQuery(document).scrollTop() > 150 && jQuery(window).width() > 1000) {
            jQuery("header").addClass("-shrink");
            mainDIVspacing();
        }
        else {
            jQuery("header").removeClass("-shrink");
        }
    }

    $('#searchDesktop').on('click', function (e) {
        e.preventDefault();
        $('#form, .desktop').toggleClass('-active');
        $(this).find('i').toggleClass('fas fa-search').toggleClass('fas fa-times-circle');
    })

});